var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../../App/styles/GlobalStyle.css";
import "../styles/ServicesForm.css";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";
import { getStatus } from "../services/ServiceStatus";
function ServicesForm(_a) {
    var contentSuppliersData = _a.contentSuppliersData, servicesAction = _a.servicesAction, callbackServicesAction = _a.callbackServicesAction;
    var _b = useState({}), selectedActions = _b[0], setSelectedActions = _b[1];
    var _c = useState(servicesAction), servicesActions = _c[0], setServicesActions = _c[1];
    useEffect(function () {
        callbackServicesAction(servicesActions);
    }, [servicesActions]);
    var handleSelectChange = function (event, product) {
        var selectedAction = typeof event === "string" ? event : event.target.value;
        setSelectedActions(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[product.id] = selectedAction, _a)));
        });
        if (selectedAction === "select") {
            var updatedServicesActions = servicesActions.filter(function (service) {
                return service.content_supplier_product_id !== product.id;
            });
            setServicesActions(updatedServicesActions);
            setSelectedActions(function (prev) {
                var next = __assign({}, prev);
                delete next[product.id];
                return next;
            });
            return;
        }
        var newServicesAction = {
            action: selectedAction,
            content_supplier_product_id: product.id,
            service: product.name,
            group_id: product.group_id,
            new_status: getStatus(selectedAction)
        };
        setServicesActions(function (prevActions) { return __spreadArray(__spreadArray([], prevActions, true), [newServicesAction], false); });
    };
    return (_jsxs("div", __assign({ className: "container-services-form" }, { children: [_jsx("h3", { children: "Servi\u00E7os" }), contentSuppliersData.map(function (supplier) {
                return (_jsxs(Accordion, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, {}), "aria-controls": "panel1-content", id: "panel1-header" }, { children: _jsx("h5", { children: supplier.name }) })), _jsx(AccordionDetails, { children: _jsx("div", __assign({ className: "accordion-table-services" }, { children: _jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Produto" }), _jsx("th", { children: "A\u00E7\u00E3o" })] }) }), _jsx("tbody", { children: supplier.content_supplier_products.length > 0 ?
                                                (supplier.content_supplier_products.map(function (product) {
                                                    var _a;
                                                    return (_jsxs("tr", { children: [_jsx("td", { children: product.name }), _jsx("td", __assign({ style: { width: "80px" } }, { children: _jsxs("select", __assign({ value: (_a = selectedActions[product.id]) !== null && _a !== void 0 ? _a : "select", onChange: function (e) { return handleSelectChange(e, product); }, disabled: !product.is_active_to_customer }, { children: [_jsx("option", __assign({ value: "select" }, { children: "Selecionar a\u00E7\u00E3o" })), product.is_active_to_customer
                                                                            && _jsx("option", __assign({ value: "activate" }, { children: "Ativar" }))] })) }))] }, product.id));
                                                })) :
                                                (_jsx("tr", { children: _jsx("td", __assign({ colSpan: 3 }, { children: "Nenhum servi\u00E7o dispon\u00EDvel." })) })) })] }) })) })] }, supplier.id));
            })] })));
}
export default ServicesForm;
